import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

/**
 * Lädt Google Analytics nach Einwilligung und meldet Seitenaufrufe
 * bei jeder Navigation innerhalb der App.
 */
export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.location.pathname.startsWith('/rueckmeldung/')) initAnalytics();
    const onConsentChange = () => {
      if (window.location.pathname.startsWith('/rueckmeldung/')) return;
      initAnalytics();
      trackPageView(window.location.pathname + window.location.search);
    };
    window.addEventListener("cookieConsentChanged", onConsentChange);
    return () => window.removeEventListener("cookieConsentChanged", onConsentChange);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith('/rueckmeldung/')) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
